import { Link } from "react-router-dom";
import { GoogleLogoIcon } from "@phosphor-icons/react";
import LangToggle from "@/components/LangToggle";
import { useLang } from "@/context/LangContext";

const COPY = {
  en: {
    kicker: "Welcome back",
    title: "Sign in to Gamly",
    desc: "Continue with Google to start using your AI sports companion.",
    google: "Continue with Google",
    terms: "By continuing you agree to Gamly AI's Terms and Privacy.",
  },
  es: {
    kicker: "Bienvenido de nuevo",
    title: "Inicia sesión en Gamly",
    desc: "Continúa con Google para empezar a usar tu compañero deportivo con IA.",
    google: "Continuar con Google",
    terms: "Al continuar, aceptas los Términos y la Privacidad de Gamly AI.",
  },
};

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function Login() {
  const { lang } = useLang();
  const c = COPY[lang];
  const handleGoogleLogin = () => {
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-[#050505] text-white flex flex-col">
      <header className="border-b border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 h-14 flex items-center justify-between">
          <Link to="/" data-testid="brand-logo" className="flex items-center gap-1.5 shrink-0">
            <img src="/gamly-logo.png" alt="Gamly AI" className="h-9 w-auto" />
            <span className="text-[9px] font-black uppercase tracking-[0.12em] text-[#0A84FF] bg-[#0A84FF]/12 border border-[#0A84FF]/30 rounded px-1 py-0.5 leading-none" data-testid="beta-badge">Beta</span>
          </Link>
          <LangToggle />
        </div>
      </header>
      <div className="flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-md bg-[#121212] border border-white/10 rounded-md p-8">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#32D74B] mb-2" data-testid="login-kicker">{c.kicker}</p>
          <h1 className="font-display font-bold text-4xl uppercase tracking-tighter mb-2" data-testid="login-title">{c.title}</h1>
          <p className="text-white/60 text-sm mb-8">{c.desc}</p>
          <button
            data-testid="google-signin-btn"
            onClick={handleGoogleLogin}
            className="w-full inline-flex items-center justify-center gap-3 py-3 rounded-md bg-white text-black font-bold uppercase tracking-wider hover:bg-white/90 transition-colors"
          >
            <GoogleLogoIcon weight="bold" /> {c.google}
          </button>
          <p className="mt-6 text-xs text-white/40 text-center">{c.terms}</p>
        </div>
      </div>
    </div>
  );
}
